import PropTypes from 'prop-types'
import Accordion from '@material-ui/core/Accordion'
import Box from '@material-ui/core/Box'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionActions'
import { IconBigPlus, IconBigMinus } from '@components/atoms/icons'
import ScenicAccordionItem from './scenic-accordion-item'
import ScenicAccordionItemVariant from './scenic-accordion-item-variant'
import useStyles from './scenic-accordion.styles'

const ScenicAccordion = (props) => {
  const {
    heading,
    supportiveCopy,
    accordionCollection,
    variant,
  } = props
  const styles = useStyles()

  const CustomExpandIcon = () => {
    return (
      <Box>
        <div className="expandIconWrapper">
          <IconBigPlus />
        </div>
        <div className="collapseIconWrapper">
          <IconBigMinus />
        </div>
      </Box>
    )
  }

  return (
    <div className={styles.root}>
      <div className={styles.maxWidthContainer}>
        <div className={styles.introContainer}>
          <div>
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.supportiveCopy}>{supportiveCopy}</p>
          </div>
        </div>
        {accordionCollection?.items && accordionCollection.items.map((accordion, i) => (
          <Accordion className={styles.accordion} key={`accordion-${i + 1}`}>
            <AccordionSummary expandIcon={<CustomExpandIcon />} className={styles.accordionTitle}>
              <div className={`${styles.titleIcon} scenic-accordion-list-icon`}>
                <object
                  aria-hidden
                  id={`scenic-accordion-object-${i}`}
                  width="16"
                  height="16"
                  className=""
                  type="image/svg+xml"
                  data={accordion.accordionTitleIcon.url}
                  aria-label=" "
                />
              </div>
              {accordion.accordionTitle}
            </AccordionSummary>
            <AccordionDetails className={styles.accordionDetails}>
              {variant
                ? <ScenicAccordionItemVariant index={i} {...accordion} />
                : <ScenicAccordionItem index={i} {...accordion} />}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  )
}

ScenicAccordion.propTypes = {
  headline: PropTypes.string,
  heading: PropTypes.string,
  supportiveCopy: PropTypes.string,
  accordionCollection: PropTypes.object,
  variant: PropTypes.bool,
}

ScenicAccordion.defaultProps = {}

export default ScenicAccordion
